import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';

// helpers
import * as tracking from 'dibs-tracking';
import { isEmailOnly } from 'dibs-cookie-jar/src/helpers/emailOnlyHelpers';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { SeoLinkComponent as SeoLink } from 'dibs-seo/exports/SeoLink';
import { getInvoiceHref } from '../helpers/getInvoiceHref';
import get from 'lodash.get';

function onInvoiceClick({ event, user, invoiceLink }) {
    event.preventDefault();
    const emailOnly = isEmailOnly(document.cookie);
    if (emailOnly) {
        const email = get(user, 'profile.email');
        authModalLoader
            .show({
                action: authModalLoader.constants.REQUEST_PASSWORD_EMAIL,
                flow: authModalLoader.constants.CREATE_PASSWORD_INVOICE_FLOW,
                email,
            })
            .then(({ userId }) => {
                if (userId) {
                    window.location.href = invoiceLink;
                }
            });
    } else {
        window.location.href = invoiceLink;
    }
    tracking.trackEvent({
        category: 'product',
        action: 'view invoice',
        label: 'pdp description',
    });
}

export function PdpSharedDetailItemInvoiceComponent({ item, skuId, user }) {
    const itemId = item?.serviceId;
    const invoiceLink = getInvoiceHref(itemId, skuId);
    return (
        <div>
            <SeoLink
                linkData={{
                    path: invoiceLink,
                    isLinkable: false,
                }}
                target="_blank"
                dataTn="pdp-spec-item-invoice"
                onClick={event => onInvoiceClick({ event, user, invoiceLink })}
            >
                <FormattedMessage id="pdpDetails.invoiceLink" defaultMessage="View Invoice" />
            </SeoLink>
        </div>
    );
}

PdpSharedDetailItemInvoiceComponent.propTypes = {
    item: PropTypes.object.isRequired,
    skuId: PropTypes.string,
    user: PropTypes.object,
};

export const PdpSharedDetailItemInvoice = createFragmentContainer(
    PdpSharedDetailItemInvoiceComponent,
    {
        user: graphql`
            fragment PdpSharedDetailItemInvoice_user on User {
                profile {
                    email
                }
            }
        `,
        item: graphql`
            fragment PdpSharedDetailItemInvoice_item on Item {
                serviceId
            }
        `,
    }
);
